// src/config/flags.ts
export const DISABLE_AUTH =
  (import.meta as any)?.env?.VITE_DISABLE_AUTH === 'true' ||
  process.env.VITE_DISABLE_AUTH === 'true' ||
  false;
